(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_kdh-quick-filters"] && !Shopify.designMode) return;
  try {
    class KdhQuickFilters extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      this.addEventListener('click', this.#onClick);
      this.#setStickyOffset();
      window.addEventListener('resize', this.#setStickyOffset, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.#setStickyOffset);
    }

    #setStickyOffset = () => {
      const header = document.querySelector('#header-component, header.header, .header-section');
      let offset = 0;
      if (header) {
        const pos = getComputedStyle(header).position;
        if (pos === 'sticky' || pos === 'fixed') offset = header.getBoundingClientRect().height;
      }
      this.style.setProperty('--kdh-sticky-offset', `${Math.round(offset)}px`);
    };

    #facets() {
      return document.querySelector('facets-form-component');
    }

    #navigate(url) {
      this.querySelector('.kdh-qf__row')?.scrollTo({ left: 0, behavior: 'smooth' });
      const facets = this.#facets();
      if (facets && typeof facets.updateFiltersByURL === 'function') {
        facets.updateFiltersByURL(url);
      } else {
        window.location.href = url;
      }
    }

    #onClick = (event) => {
      const openButton = event.target.closest('[data-kdh-open-filters]');
      if (openButton) {
        event.preventDefault();
        const drawer = document.getElementById('filters-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          document.querySelector('.facets-toggle__button')?.click();
        }
        return;
      }

      const sortChip = event.target.closest('[data-kdh-sort]');
      if (sortChip) {
        event.preventDefault();
        const url = new URL(window.location.href);
        const value = sortChip.dataset.kdhSort;
        if (url.searchParams.get('sort_by') === value) {
          url.searchParams.delete('sort_by');
        } else {
          url.searchParams.set('sort_by', value);
        }
        url.searchParams.delete('page');
        this.#navigate(url.toString());
        return;
      }

      const filterChip = event.target.closest('[data-kdh-filter]');
      if (filterChip) {
        event.preventDefault();
        const url = new URL(filterChip.getAttribute('href'), window.location.origin);
        url.searchParams.delete('page');
        this.#navigate(url.toString());
      }
    };
  }

  if (!customElements.get('kdh-quick-filters')) {
    customElements.define('kdh-quick-filters', KdhQuickFilters);
  }
  } catch(e) { console.error(e); }
})();

})();
